import React from "react";
import { Link } from "react-router-dom";
import type { Lang } from "./types";
import { analytics } from "@/lib/analytics";

interface FooterProps {
  lang: Lang;
}

export function Footer({ lang }: FooterProps) {
  const year = new Date().getFullYear();
  const terms = lang === "es" ? "Términos" : "Terms";
  const privacy = lang === "es" ? "Privacidad" : "Privacy";
  const returns = lang === "es" ? "Devoluciones" : "Returns";
  const affiliates = lang === "es" ? "Afiliados" : "Affiliates";
  const rights = lang === "es" ? "Todos los derechos reservados" : "All rights reserved";
  const refTitle = lang === "es" ? "Invita amigos y gana" : "Refer friends & earn";
  const refCopy = lang === "es"
    ? "Tu amigo recibe 15% off · tú ganas 500 pts (y desbloqueas descuentos permanentes)."
    : "Your friend gets 15% off · you earn 500 pts (and unlock permanent perks).";
  const refCta = lang === "es" ? "Obtener mi código" : "Get my code";

  return (
    <footer className="nm-ft" aria-label={lang === "es" ? "Pie de página" : "Footer"}>
      <div className="nm-ft-ref" data-testid="footer-referral">
        <div className="nm-ft-ref-text">
          <strong>🎁 {refTitle}</strong>
          <span>{refCopy}</span>
        </div>
        <Link
          to="/referral"
          className="nm-ft-ref-cta"
          onClick={() => analytics.referralFooterClick({ lang })}
        >{refCta}</Link>
      </div>
      <div className="nm-ft-inner">
        <span className="nm-ft-copy">
          © {year} NutriMart RD · {rights}
        </span>
        <nav className="nm-ft-nav" aria-label={lang === "es" ? "Legal" : "Legal"}>
          <Link to="/legal/terminos" className="nm-ft-lk">{terms}</Link>
          <Link to="/legal/privacidad" className="nm-ft-lk">{privacy}</Link>
          <Link to="/legal/devoluciones" className="nm-ft-lk">{returns}</Link>
          <Link to="/afiliados" className="nm-ft-lk">{affiliates}</Link>
          <Link to="/referral" className="nm-ft-lk">{lang === "es" ? "Referidos" : "Referrals"}</Link>
        </nav>
      </div>
    </footer>
  );
}
